import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { Project } from "../../../models/project";
import { CachedProjectService } from "../../../shared/services/cached-project.service";
import { CachedUserService } from "../../../shared/services/cached-user.service";
import { RebuildTableComponent } from "../../project/dialogs/rebuild-project-table/rebuild-project-table.component";
import { ButtonConfig } from "../data-table/custom-table/custom-table.component";
import { env_vars_fields } from "./fields";

@Component({
    selector: "app-env-vars",
    templateUrl: "./env-vars.component.html",
    styleUrls: ["./env-vars.component.css"],
    standalone: false
})
export class EnvVarsComponent implements OnInit, OnDestroy {
  private _userSubscription: any;
  private _projectSubscription: Subscription;
  private _envVarsTableSubscription: Subscription;

  project_id: string;
  project_name: string;
  is_loading: boolean = false;
  data: Array<any> = [];
  options: Object = env_vars_fields;
  
  linkDefinitions: Array<any> = [
    {
      key: "job_name",
      template: (row: object) => `projects/${row["job_id"]}/model`,
    },
  ];

  buttonConfig: ButtonConfig[] = [];

  inMenuButtonConfig: ButtonConfig[] = [
    {
      text: "Rebuild Table",
      action: (event, info) => {
        this.rebuildTable();
      },
    },
    {
      text: "Refresh Table",
      action: (event, info) => {
        this.refreshTable();
      },
    },
  ];

  headerTooltips: object = {};
  landingJobs: object[] = [];

  constructor(
    private router: Router,
    private cachedProjectService: CachedProjectService,
    public dialog: MatDialog,
    private userService: CachedUserService,
    public snackBar: MatSnackBar,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    this._userSubscription = this.userService.userDetail.subscribe((d) => {
      // User permissions check if needed
    });
    
    this._projectSubscription =
      this.cachedProjectService.currentProject.subscribe((project: Project) => {
        if (project != null) {
          this.project_id = project.id;
          this.project_name = project.name;
          this.getProjectLevelEnvVars();
        }
      });
  }

  ngOnDestroy(): void {
    if (this._envVarsTableSubscription) {
      this._envVarsTableSubscription.unsubscribe();
    }
    this._userSubscription.unsubscribe();
    this._projectSubscription.unsubscribe();
  }

  async getProjectLevelEnvVars(rebuild: boolean = false, forceRefresh: boolean = false) {
    this.is_loading = true;
    let env_vars_jobs = this._route.snapshot.queryParams.jobs || [];

    this._envVarsTableSubscription = this.cachedProjectService
      .getProjectLevelEnvVars(this.project_id, rebuild, env_vars_jobs, forceRefresh)
      .pipe(take(1))
      .subscribe(
        (data) => {
          this.landingJobs = this._route.snapshot.queryParams.jobs;
          this.data = [...data["results"]];
          this.is_loading = false;
        },
        (err) => {
          console.log(err);
          this.is_loading = false;
        }
      );
  }

  refreshTable() {
    this.getProjectLevelEnvVars(false, true);
  }

  rebuildTable() {
    this.dialog
      .open(RebuildTableComponent, {
        height: "320px",
        width: "400px",
        data: {
          project_name: this.project_name,
        },
      })
      .afterClosed()
      .pipe(take(1))
              .subscribe((result) => {
          if (result != undefined && result["confirm"]) {
            this.getProjectLevelEnvVars(true);
          }
        });
  }
}
